import LoadingModalProvider from "./LoadingModalProvider";

export default LoadingModalProvider;
